import React, { useEffect } from 'react';
import { Routes, Route, BrowserRouter, useLocation } from 'react-router-dom';
import OAuthCallback from './OAuthCallback';

const CALLBACK = 'oauth-callback';
const isCallback = path => path.split('/')[1] === CALLBACK;

function Noop() {
    return null;
}

/**
 * This is the real "entrypoint" of the auth micro frontend.
 *
 * The actual root component takes care of interacting with `@alli/frontend-common`
 * so this remains isolated, and, theoretically, testable.
 */
export default function OAuthFlow({
    currentAccessToken,
    accessToken,
    setAccessToken,
    oauth,
    redirect,
}) {
    const location = useLocation();

    useEffect(() => {
        // no access token and not on an auth route: we can bail
        if (!currentAccessToken && !isCallback(location.pathname)) {
            oauth.redirectToLogin(location.pathname + location.search).then(url => {
                redirect(url);
                return url;
            });
            return null;
        }
    }, [oauth, redirect, location, currentAccessToken]);

    return (
        <Routes>
            <Route
                path={`/${CALLBACK}`}
                element={<OAuthCallback oauth={oauth} setAccessToken={setAccessToken} />}
            />
            <Route path="*" element={<Noop />} />
        </Routes>
    );
}
